<nav class="top-nav">
  <div class="nav-content">
    <div class="nav-left">
      <a routerLink="/" class="nav-logo" [attr.aria-label]="'nav.home' | translate" [attr.title]="'nav.home' | translate">
        <img src="assets/logo.svg" alt="Freyr" class="nav-logo-img" />
        <span class="nav-logo-text">Freyr</span>
      </a>
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">{{ 'nav.home' | translate }}</a>
      @if (authService.isLoggedIn && authService.user) {
        <a routerLink="/dashboard" routerLinkActive="active" class="nav-link">{{ 'nav.dashboard' | translate }}</a>
      }
    </div>

    <div class="nav-right">
		<!--      <div class="nav-lang-wrap" #langWrap>-->
		<!--        <button type="button" class="nav-lang-trigger" (click)="toggleLangDropdown()" [attr.aria-expanded]="langDropdownOpen" [attr.aria-haspopup]="'true'" [attr.title]="(translate.currentLang === 'fr' ? 'nav.languages.fr' : 'nav.languages.en') | translate">-->
		<!--          <img [src]="currentLangFlagSrc" alt="" class="nav-lang-flag" width="24" height="16" />-->
		<!--          <ui-inline-svg icon="chevron-down" iconClass="nav-dropdown-chevron"></ui-inline-svg>-->
		<!--        </button>-->
		<!--        @if (langDropdownOpen) {-->
		<!--          <div class="nav-dropdown">-->
		<!--            @for (lang of languages; track lang.code) {-->
		<!--              <button type="button" class="nav-dropdown-item nav-dropdown-item&#45;&#45;lang" (click)="selectLang(lang.code)">-->
		<!--                <img [src]="lang.flagSrc" alt="" class="nav-lang-item-flag" width="22" height="15" />-->
		<!--                <span>{{ lang.labelKey | translate }}</span>-->
		<!--              </button>-->
		<!--            }-->
		<!--          </div>-->
		<!--        }-->
		<!--      </div>-->

<!--      <button-->
<!--        type="button"-->
<!--        class="nav-btn-theme"-->
<!--        (click)="themeService.toggle()"-->
<!--        [attr.aria-label]="(themeService.currentTheme === 'dark' ? 'nav.themeLight' : 'nav.themeDark') | translate"-->
<!--        [attr.title]="(themeService.currentTheme === 'dark' ? 'nav.themeLightTitle' : 'nav.themeDarkTitle') | translate"-->
<!--      >-->
<!--        @if (themeService.currentTheme === 'dark') {-->
<!--          <ui-inline-svg icon="theme-sun" iconClass="theme-toggle-icon"></ui-inline-svg>-->
<!--        } @else {-->
<!--          <ui-inline-svg icon="theme-moon" iconClass="theme-toggle-icon"></ui-inline-svg>-->
<!--        }-->
<!--      </button>-->

      @if (authService.isLoggedIn && authService.user) {
        <div class="nav-user-wrap" #userWrap>
          <button type="button" class="nav-user-trigger" (click)="toggleUserDropdown()" [attr.aria-expanded]="userDropdownOpen" [attr.aria-haspopup]="'true'" [attr.title]="authService.user.username">
            @if (authService.user.profileImageUrl) {
              <img [src]="authService.user.profileImageUrl" alt="" class="nav-user-avatar" width="32" height="32" />
            } @else {
              <span class="nav-user-initial">{{ authService.user.username.charAt(0) | uppercase }}</span>
            }
            <span class="nav-user-name">{{ authService.user.username }}</span>
            <ui-inline-svg icon="chevron-down" iconClass="nav-dropdown-chevron"></ui-inline-svg>
          </button>
          @if (userDropdownOpen) {
            <div class="nav-dropdown nav-dropdown--user">
				<button type="button" class="nav-dropdown-item" routerLink="/dashboard/settings"
	                    (click)="closeUserDropdown()">{{ 'settings.title' | translate }}
	            </button>
              @if (canAccessAdmin) {
                <button type="button" class="nav-dropdown-item" (click)="goToAdmin()">{{ 'nav.adminPanel' | translate }}</button>
              }
<!--              <button type="button" class="nav-dropdown-item" routerLink="/dashboard/access" (click)="closeUserDropdown()">{{ 'dashboard.layout.accessLabel' | translate }}</button>-->
              <button type="button" class="nav-dropdown-item" (click)="logout(); closeUserDropdown()">{{ 'nav.logout' | translate }}</button>
            </div>
          }
        </div>
      } @else {
        <ui-button class="nav-login-button" variant="primary" size="sm" layout="inline" (click)="goToLogin()">
          {{ 'nav.login' | translate }}
        </ui-button>
      }
    </div>
  </div>
</nav>

